module.exports = __webpack_public_path__ + "static/media/6_School of the animals_TI.0b40b882.txt";